import { TREND_FALLING, TREND_RISING, TREND_STEADY } from '../helpers/DataTrend.js';
import { STATUS_NO_DATA, STATUS_NO_RECENT_DATA, STATUS_WARNING, FLOOD_LEVEL_MINOR, FLOOD_LEVEL_MODERATE, FLOOD_LEVEL_MAJOR } from '../helpers/SiteDataConst.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWater, faWaterArrowDown, faWaterArrowUp, faExclamationTriangle, faWifiSlash } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';

function getStatusIcon(status) {
  switch(status) {
    case TREND_RISING:
      return faWaterArrowUp;
    case TREND_FALLING:
      return faWaterArrowDown;
    case TREND_STEADY:
      return faWater;
    case STATUS_NO_DATA:
    case STATUS_NO_RECENT_DATA:
      return faWifiSlash;
    case STATUS_WARNING:
    case FLOOD_LEVEL_MINOR:
    case FLOOD_LEVEL_MODERATE:
    case FLOOD_LEVEL_MAJOR:
      return faExclamationTriangle;
    default:
      return undefined;
  }
}

function StatusIcon({status, className}) {
  const icon = getStatusIcon(status);
  if (!icon) {
    return null;
  }

  return (
    <FontAwesomeIcon icon={icon} className={className} />
  );
}

export default StatusIcon
